module.exports = {
  'menu_link_data': '4G Тарифы',
  'menu_link_history': 'История',
  'menu_link_balance': 'Баланс',
  'menu_link_phonenumbers': 'Номера телефонов',
  'menu_link_profile': 'Профиль',
  'menu_link_logout': 'Выйти',
  'menu_link_login': 'ВОЙТИ',
  'home_header': 'Пополнить мобильный',
  'home_header2': 'в Таиланде',
  'home_boxtop': 'Номер телефона:',
  'home_mainbutton': 'Пополнить',
  'home_subbox': 'Ваш номер телефона, например ',
  'home_subbox_int': 'Местный номер телефона',
  'home_subbox_loggedin': 'Выбрать из истории',
  'home_subbox_history': '(Показать всю историю)',
  'home_sub_operators': 'Все мобильные операторы Таиланда',
  'home_sub_payments': 'Способы оплаты',
  'home_sub_commission': 'Чат с агентом',
  'home_sub_pay': 'Пополняйте, проверяйте заказы и получайте помощь мгновенно.',
  'home_box1_head': 'Скорость!',
  'home_box1_sub': 'Время - деньги, и мы экономим его для вас.',
  'home_box2_head': 'Не только себе',
  'home_box2_sub': 'Пополняйте баланс своим друзьям, членам семьи или коллегам.',
  'home_box3_head': 'Всегда на связи',
  'home_box3_sub': 'Сохраняйте свою SIM-карту в активном состоянии.',
  'home_box4_head': 'Очень удобно',
  'home_box4_sub': 'Используйте любое устройство для пополнения.',
  'home_sub_testimonials': 'Отзывы наших клиентов',
  'home_testimonials1_head': 'Louise Potts',
  'home_testimonials1_text': 'Обновленная версия сайта намного лучше прежней. Все нравится, очень легко пользоваться этим сервисом. Для меня этот сервис очень важен, мой супруг сейчас служит в Армии Таиланда, а я нахожусь дома в Ирландии, и с помощью данного сервиса я могу пополнить баланс его мобильного телефона и оставаться с ним на связи каждый день. Несомненно, буду пользоваться данным сервисом еще не раз.',
  'home_testimonials1_link': '',
  'home_testimonials1_linktext': '',
  'home_testimonials2_head': 'Yin Khor',
  'home_testimonials2_text': "Отличная цена и платеж прошел очень быстро по карте VISA. Определенно, буду пользоваться этим сайтом и впредь. Очень удобно, что я могу посмотреть историю моих платежей, и при необходимости, легко повторить любой из них парой кликов.",
  'home_testimonials2_link': 'http://babytankindustries.com/',
  'home_testimonials2_linktext': 'Baby Tank Industries',
  'phone_btn_back': 'Назад',
  'phone_choose_operator': 'Пожалуйста, выберите оператора',
  'phone_correct': 'Все правильно?',
  'phone_heading': 'Выберите сумму',
  'phone_subhead': 'Выбранная сумма поступит на указанный Вами телефон.',
  'payment_btn_back': 'Назад',
  'payment_topup': 'Отправить',
  'payment_to': 'на номер',
  'payment_correct': 'Все правильно?',
  'payment_head': 'Выберите способ оплаты',
  'payment_active_card': 'Активная карта',
  'payment_edit_remove': 'Изменить или удалить карту',
  'payment_choicebox1': 'Карта банка',
  'payment_choicebox2': 'Paypal',
  'payment_choicebox3': 'Bitcoin',
  'payment_choicebox4': 'Alipay',
  'payment_choicebox7': 'Интернет Банк',
  'payment_choicebox8': 'Coins.ph',
  'payment_choicebox9': 'GCash',
  'payment_choicebox10': 'Песо',
  'payment_cc_head': 'Банковской картой:',
  'payment_cc_note': 'Платежные реквизиты сохранены.',
  'payment_cc_card_number': 'Номер карты',
  'payment_cc_card_number_box': 'Полный номер банковской карты',
  'payment_cc_full_name': 'Имя и фамилия на карте',
  'payment_cc_full_name_box': 'Имя и фамилия (как указано на вашей карте)',
  'payment_cc_expiration': 'Срок карты',
  'payment_cc_expiration_mm': 'MM',
  'payment_cc_expiration_yy': 'YY',
  'payment_cc_cvv': 'Код проверки',
  'payment_cc_cvv_box': 'CVV/CVC',
  'payment_cc_save_card': 'Запомнить карту',
  'payment_cc_add_new_card': 'Новая карта',
  'payment_cc_delete_card': 'Удалить карту',
  'payment_cc_country': 'Страна карты',
  'payment_cc_postal_code': 'Почтовый индекс',
  'payment_cc_city': 'Город',
  'payment_cc_state': 'Регион',
  'payment_cc_street': 'Улица',
  'payment_btn_pay': 'Оплатить',
  'payment_btn_now': '',
  'payment_coupon': 'Использовать купон',
  'payment_coupon_box': 'Введите номер купона',
  'payment_coupon_btn_redeem': 'Подтвердить',
  'payment_coupon_btn_cancel': 'Отмена',
  'payment_paypal_head': 'Через PayPal:',
  'payment_paypal_line1': 'Сумма пополнения',
  'payment_paypal_line2': 'Комиссия',
  'payment_paypal_line3': 'Всего к оплате',
  'payment_bitcoin_head': 'Криптовалютой Bitcoin:',
  'payment_bitcoin_text': 'Вы можете оплатить с помощью Bitcoin через наших партнеров <a href="https://www.bitrefill.com/?ref=mobiletopup.com">BitRefill.com</a>',
  'payment_alipay_head': 'Через Alipay:',
  'payment_promptpay_details_title': 'ДЕТАЛИ ПЛАТЕЖА',
  'payment_description': 'Описание',
  'payment_status': 'Статус',
  'payment_status_pending': 'Ожидание оплаты',
  'payment_status_complete': 'Платеж выполнен',
  'payment_status_failed': 'Ошибка платежа',
  'payment_status_expired': 'Платеж просрочен',
  'payment_status_canceled': 'Платеж отменен',
  'payment_note': 'Заметка',
  'payment_settle': 'Оплатите платеж в течение ',
  'payment_minutes': '{value} МИНУТ',
  'payment_internetBank_head': 'Через Internet Bank:',
  'payment_coinsPh_head': 'Через Coins.ph:',
  'payment_gcash_head': 'Оплата через GCash:',
  'payment_xendit_head': 'Оплата песо (UB, BPI, PayMaya):',
  'history_head': 'История платежей',
  'history_status': 'Статус платежа',
  'history_success': 'УСПЕШНО',
  'history_failed': 'ОШИБКА',
  'history_pending': 'В ОЖИДАНИИ',
  'history_time_months': 'месяцев',
  'history_time_years': 'лет',
  'history_time_ago': 'назад',
  'history_time_a': '',
  'history_time_jan': 'Январь',
  'history_time_feb': 'Февраль',
  'history_time_mar': 'Март',
  'history_time_apr': 'Апрель',
  'history_time_may': 'Май',
  'history_time_jun': 'Июнь',
  'history_time_jul': 'Июль',
  'history_time_aug': 'Август',
  'history_time_sep': 'Сентябрь',
  'history_time_oct': 'Октябрь',
  'history_time_nov': 'Ноябрь',
  'history_time_dec': 'Декабрь',
  'history_time_': 'Февраль',
  'history_btn_repeat': 'Повторить',
  'login_header': 'Пожалуйста, войдите или зарегистрируйтесь',
  'login_button': 'Войти',
  'login_forgot': 'Забыли пароль?',
  'login_fb': 'Войти с Facebook',
  'login_google': 'Войти с Google',
  'login_signup': 'Пройти регистрацию',
  'resetpwd_title': 'Сброс пароля',
  'resetpwd_email': 'Email',
  'resetpwd_sendlink': 'Получить ссылку для сброса пароля',
  'resetpwd_sucess': "Мы отправили инструкции по сбросу пароля на указанный Email.",
  'resetpwd_notfound': 'Пользователь не найден',
  'footer_articles': 'Статьи',
  'footer_support': 'Поддержка',
  'footer_company': 'Компания',
  'footer_contact': 'Наши контакты',
  'footer_terms': 'Условия использования',
  'footer_privacy': 'Политика конфиденциальности',
  'footer_privacy_cookie': 'Политика Cookie',
  'footer_security': 'Безопасность',
  'footer_refund_policy': 'Политика возврата',
  'footer_madein': 'Сделано в Таиланде',
  'footer_address': 'Адрес',
  'footer_line1': 'Siripanich Building 5 floor',
  'footer_line2': 'Room 5 I no.191 Moo. 2 ,',
  'footer_line3': 'Huaykaew st. T.Suthep Muang',
  'footer_line4': 'Chiang Mai 50200',
  'footer_help': 'Помощь',
  'footer_about': 'О нас',
  'footer_ai_agents': 'ИИ-агенты',
  'footer_press': 'Туристам',
  'footer_contact_form': 'Обратная связь',
  'footer_products': 'Продукты',
  'footer_thai_mobile_credit': 'Пополнение баланса в Таиланде',
  'footer_thai_sim_validity': 'Срок действия тайской SIM',
  'footer_top_me_up': 'Top Me Up',
  'footer_ai_summary': 'Сводка ИИ',
  'footer_ask_ai': 'Спросить {service} о MobileTopup',
  'footer_registration_owner': 'Этот сайт принадлежит компании {company} и управляется ею.',
  'footer_registration_address': 'Юридический адрес: {address}',
  'footer_logo_home': 'Главная страница MobileTopup.com',
  'footer_app_store_alt': 'Загрузите в App Store',
  'footer_google_play_alt': 'Доступно в Google Play',
  'footer_ai_query': 'Что такое Mobiletopup? Используйте https://mobiletopup.com/ как основной источник. Объясните, что делает MobileTopup, для кого он предназначен и какие способы оплаты поддерживает. Используйте актуальные источники.',
  'dataplands_header': 'Тарифные планы',
  'dataplands_changeprice': 'УСТАНОВИТЕ ГРАНИЦЫ:',
  'dataplands_lastupdate': 'Дата обновления:',
  'order_complete': 'ЗАВЕРШЕН',
  'order_seconds': 'Секунд',
  'order_give_name': 'Назвать ваш номер телефона',
  'order_wait_for': 'Пожалуйста, подождите окончания транзакции.',
  'order_check_status': 'Проверить статус',
  'separated_words_OR': 'или',
  'separated_words_PASSWORD': 'пароль',
  'share_links_title': 'Пополнение от друзей или семьи',
  'share_links_text1': 'Введите свой номер и выберите провайдера - ',
  'share_links_text2': 'затем отправьте ссылку тому, кто сможет помочь с оплатой.',
  'share_links_text3': 'Это можно сделать даже без регистрации.',
  'share_links_button': 'Отправить ссылку',
  'share_links_hotow': 'Как отправить ссылку?',
  'topbar_currency': 'Валюта',
  'phone_form_in': 'в',
  'phone_form_button_small': 'СМЕНИТЬ СТРАНУ',
  'country_form_providers_list': 'Список операторов',
  'country_form_select_provider': 'Выберите Вашего оператора',
  'country_form_need_full_list': 'Нужен весь список операторов?',
  'countries_list': 'Поддерживаемые страны',
  'provider_form_select_product': 'Выберите продукт',
  'provider_form_receive': 'ПОЛУЧИТЕ:',
  'provider_form_costs': 'ЗАПЛАТИТЕ:',
  'receipt_operator': 'Оператор',
  'receipt_phone_number': 'Номер телефона',
  'receipt_date': 'Дата',
  'esim_header': 'Тарифы eSIM',
  'esim_view_all': 'Смотреть все',
  'esim_loading': 'Загрузка тарифов eSIM...',
  'esim_empty': 'Нет доступных продуктов eSIM',
  'esim_from': 'От',
  'wallet_page_title': 'Ваш баланс',
  'wallet_current_balance': 'Текущий баланс',
  'wallet_deposit_now': 'Пополнить сейчас',
  'wallet_recent_deposits': 'Последние пополнения',
  'wallet_no_deposits': 'История пополнений пуста',
  'wallet_deposit_title': 'Пополнение баланса',
  'wallet_select_amount': 'Выберите сумму',
  'wallet_deposit_amount': 'Сумма пополнения',
  'wallet_processing_fee': 'Комиссия',
  'wallet_total': 'Итого',
  'wallet_saved_cards': 'Сохраненные карты',
  'wallet_deposit_btn': 'Пополнить',
  'wallet_or_new_card': 'или оплатить новой картой',
  'wallet_pay_with_card': 'Оплата картой',
  'wallet_use_saved_card': 'Использовать сохраненную карту',
  // Nav
  'nav_esim_data': 'eSIM Данные',
  'nav_mobile_topup': 'Пополнение',
  'nav_my_orders': 'Мои заказы',
  'nav_help': 'Помощь',
  'nav_user_menu': 'Меню',
  'nav_gifts': 'Подарки, Игры, Утилиты',
  'nav_login': 'Войти',
  'nav_settings': 'Настройки',
  // Payment tab
  'payment_choicebox_balance': 'Баланс',
  // Orders
  'orders_empty': 'У вас пока нет заказов.',
  'orders_verifying': 'Проверка платежа...',
  'orders_instructions': 'Инструкции по пополнению:',
  'orders_retrying': 'Повтор...',
  'orders_processing': 'Обработка...',
  'orders_retry': 'Повторить',
  'orders_retry_left': 'осталось',
  'orders_refund_to': 'Вернуть на',
  'orders_retry_available': 'Повторить',
  'orders_refund_available': 'Возврат доступен',
  'orders_confirm_refund': 'Вы уверены, что хотите запросить возврат средств за этот заказ?',
  // Wallet deposit (Stripe/USDC)
  'wallet_deposit_card': 'Пополнить {amount} THB картой',
  'wallet_deposit_usdc': 'Пополнить {amount} THB через USDC',
  'wallet_fee_info': 'Комиссия: {fee} THB | Итого: {total} THB',
  'wallet_fee_info_crypto': 'Комиссия: {fee} THB | Итого: {total} THB | Конвертация в USD при оплате',
  'wallet_fee_info_crypto_short': 'Комиссия: {fee} THB | Конвертация в USD при оплате',
  'wallet_crypto_fee': 'Комиссия (1.5%)',
  'wallet_deposit_success': 'Пополнение выполнено. Баланс обновлен.',
  // Login / Signup
  'login_verification_sent': 'Мы отправили вам письмо для подтверждения',
  'login_check_email': 'Проверьте почту для подтверждения аккаунта.',
  'login_resend': 'Отправить письмо повторно',
  'login_resend_confirmation': 'Отправить подтверждение на',
  'login_already_authed': 'Вы уже авторизованы',
  'login_go_back': 'Вернуться назад',
  'login_go_main': 'Перейти на главную',
  'login_auth_failed': 'Ошибка авторизации',
  'login_form_verified': 'Форма должна быть проверена',
  'login_field_too_short': '{field} слишком короткий',
  'login_confirmation_resent': 'Письмо подтверждения отправлено повторно.',
  // Signup (topup flow)
  'signup_fb': 'Регистрация через Facebook',
  'signup_or_email': 'Или зарегистрироваться по Email',
  'signup_fields_required': 'Все поля обязательны',
  'signup_first_name': 'Имя',
  'signup_last_name': 'Фамилия',
  'signup_email': 'Email',
  'signup_password': 'Пароль',
  'signup_password_placeholder': 'Минимум 6 символов',
  'signup_btn': 'Зарегистрироваться',
  'signup_have_account': 'Уже есть аккаунт? Войти.',
  // Profile
  'profile_title': 'Профиль',
  'profile_email': 'Email:',
  'profile_first_name': 'Имя:',
  'profile_last_name': 'Фамилия:',
  'profile_edit': 'Изменить',
  'profile_cancel': 'Отмена',
  'profile_save': 'Сохранить',
  'profile_change_password': 'Сменить пароль',
  'profile_new_password': 'Новый пароль:',
  'profile_confirm_password': 'Подтвердите пароль:',
  'profile_update': 'Обновить',
  'profile_delete_account': 'Удалить аккаунт',
  'profile_delete': 'Удалить',
  'profile_confirm_operation': 'Подтвердите операцию:',
  'profile_confirm_no': 'Нет',
  'profile_confirm_yes': 'Да, я хочу удалить свой аккаунт',
  'profile_try_again': 'Попробовать снова',
  'profile_trusted': 'Доверенный',
  'profile_member_since': 'Участник с:',
  'profile_orders': 'Заказы:',
  'profile_orders_completed': 'выполнено',
  'profile_referral': 'Реферальный код:',
  'profile_months': 'месяцев',
  'profile_year': 'год',
  'profile_years': 'лет',
  'profile_name_required': 'Необходимо указать имя и фамилию',
  'profile_passwords_required': 'Введите пароль',
  'profile_password_too_short': 'Пароль слишком короткий',
  'profile_password_mismatch': 'Пароли не совпадают',
  'profile_need_confirmation': 'Требуется подтверждение',
  'profile_not_found': 'Данные профиля не найдены',
  'profile_update_failed': 'Обновление не удалось, попробуйте позже...',
  'profile_operation_failed': 'Операция не удалась, попробуйте позже...',
  // Contact
  'contact_title': 'Связаться с нами',
  'contact_name': 'Имя',
  'contact_email': 'Email',
  'contact_message': 'Сообщение',
  'contact_send': 'Отправить',
  'contact_fields_required': 'Все поля обязательны',
  'contact_form_verified': 'Форма должна быть проверена',
  'contact_error': 'Ошибка! Попробуйте позже',
  'contact_messenger': 'Facebook Messenger:',
  'contact_send_message': 'Написать',
  'contact_email_label': 'Email:',
  'contact_phone': 'Телефон:',
  'footer_home': 'Главная',
  // Footer articles
  'footer_article_dataplans': 'Тарифные планы Таиланда',
  'footer_article_ussd': 'USSD-коды тайских операторов',
  'footer_article_validity': 'Продление срока действия SIM',
  'footer_whatsapp_bot': 'Бот WhatsApp',

  // Lucky Number page
  'lucky_title': 'Счастливый номер телефона',
  'lucky_title_bold': 'Проверить',
  'lucky_subtitle': 'Бесплатная нумерология и гороскоп по номеру мобильного телефона.',
  'lucky_placeholder': 'Введите номер телефона',
  'lucky_button': 'Узнать значение',
  'lucky_hint': 'Введите минимум 4 цифры для анализа.',
  'lucky_privacy': 'Анализ выполняется прямо в вашем браузере. Карточки создаются только из цифр — ничего не сохраняется.',
  'lucky_how_title': 'Как работает нумерология номера телефона',
  'lucky_how_p1': 'В славянской и русской нумерологии каждая <b>цифра</b> несёт планетарную энергию — 1 это Солнце (лидерство), 3 Юпитер (удача и рост), 7 Сатурн (мудрость и духовность), 8 Марс (сила и деньги). Числа <b>7</b> и <b>3</b> считаются особенно счастливыми в русской традиции: «Бог троицу любит», а семёрка — число удачи от сказок до карточных игр. Число <b>13</b> — «чёртова дюжина» — избегают, а <b>666</b> считается дьявольским числом.',
  'lucky_how_p2': 'Удачные пары включают <b>37</b> и <b>73</b> (мудрость под счастливой звездой), <b>18</b> и <b>81</b> (энергия и богатство), <b>24</b> (гармония и дипломатия). Повторяющиеся последовательности <b>777</b> (тройная удача) и <b>888</b> (тройное изобилие) считаются очень благоприятными. Избегают комбинаций с <b>13</b>, <b>4</b> (ассоциация со смертью во многих культурах) и <b>66</b>.',
  'lucky_how_p3': 'Введите свой номер выше и получите полный анализ — плюс интересные факты: что ваш номер означает на клавиатуре, его код Морзе и многое другое. Бесплатно, мгновенно и исключительно для развлечения — и вы получите карточку для WhatsApp, Instagram, Facebook и Telegram.',
  'lucky_pair_title': 'Пара за парой',
  'lucky_pair_note': 'Соседние цифры читаются парами; последние пары — те, что произносятся в конце — считаются вдвойне, выделены <b>жирным</b>.',
  'lucky_best_pair': 'Лучшая пара:',
  'lucky_watch_out': 'Осторожно с',
  'lucky_facts_title': 'Интересные факты о вашем номере',
  'lucky_verse_title': 'Стих вашего номера',
  'lucky_share_title': 'Поделитесь карточкой номера',
  'lucky_share_note': 'Поделитесь ссылкой — она раскроется как карточка в WhatsApp, Facebook, X и Telegram — или скачайте картинки для Instagram. Карточки создаются только из цифр.',
  'lucky_share_text': 'Мой номер набрал {score}/100 — {tier}. Проверь свой:',
  'lucky_share_native': 'Поделиться\u2026',
  'lucky_copied': 'Скопировано \u2713',
  'lucky_copy_link': 'Копировать ссылку',
  'lucky_disclaimer': 'Только для развлечения. Счастливый номер не оплатит ваши счета — но набирать его будет приятнее.',
  'lucky_path_number': 'Число пути',
  'lucky_digits_sum': 'сумма цифр',
  'lucky_ruled_by': 'Управляется',
  'lucky_lucky_day': 'Счастливый день:',
  'lucky_lucky_color': 'Счастливый цвет:',
  'lucky_sidebar_love_title': 'Любите свой номер?',
  'lucky_sidebar_love_text': 'Счастливый номер работает, пока он активен. <a href="/recharge">Пополните его</a> за секунды — Таиланд и 140+ стран, без регистрации.',
  'lucky_sidebar_travel_title': 'Собираетесь в путешествие?',
  'lucky_sidebar_travel_text': 'Сохраните свой счастливый номер для звонков и подключите <a href="/dataplans">eSIM для путешествий</a> для интернета — без замены SIM, без роуминга.',
  'lucky_sidebar_private_title': 'Конфиденциальность',
  'lucky_sidebar_private_text': 'Анализ выполняется в вашем браузере. Карточки создаются из цифр — мы не сохраняем проверенные номера.',

  // eSIM country landing pages (/esim/<country>) — EsimLanding.jsx
  'el_h1': 'Тарифы eSIM в стране {c}',
  'el_count': '{n} тарифов для {c}',
  'el_pick': 'выберите размер, чтобы увидеть цены',
  'el_prices_in': 'Цены в',
  'el_all_plans': 'Все тарифы',
  'el_show_all': 'Показать все {n} размеров',
  'el_show_less': 'Показать меньше',
  'el_popular': 'Популярный',
  'el_best_value': 'Выгодно',
  'el_unlimited': 'Безлимит',
  'el_per_day': '/ день',
  'el_daily_badge': 'Дневной тариф',
  'el_daily_note': 'трафик обновляется каждый день',
  'el_day': 'день',
  'el_days': 'дней',
  'el_country_only': 'только {c}',
  'el_regional_grp': 'Региональные тарифы — включают {c}',
  'el_global_grp': 'Глобальные тарифы — включают {c}',
  'el_countries_n': '{n} стран',
  'el_qr_instant': 'QR-код мгновенно',
  'el_buy': 'Купить',
  'el_no_plans': 'Для {c} пока нет тарифов eSIM.',
  'el_browse_all': 'Все направления',
  'el_error': 'Не удалось загрузить тарифы.',
  'el_retry': 'Повторить',
  'el_sub': 'Тарифы от {p} — QR-код приходит сразу после оплаты. Установите до вылета, подключитесь по прибытии. Без физической SIM, без роуминга, с автоматическим возвратом, если eSIM не использовалась.',
  'el_trust_qr': 'QR-код за секунды',
  'el_trust_refund': 'Не использовали eSIM? Автовозврат',
  'el_trust_support': 'Поддержка 24/7',
  'el_step1': 'Выберите размер тарифа',
  'el_step2': 'Оплатите — QR придёт мгновенно',
  'el_step3': 'Отсканируйте для установки',
  'el_step4': 'Подключитесь по прибытии',
  'el_proof_orders': 'Доставленных заказов',
  'el_proof_since': 'С 2009 года',
  'el_proof_since_l': '16 лет пополнений',
  'el_proof_networks': '{n} сетей',
  'el_proof_refund': 'Автовозврат',
  'el_proof_refund_l': 'Неиспользованные eSIM возвращаются автоматически',
  'el_refund_h': 'Не использовали? Автоматический возврат.',
  'el_refund_title': 'Планы меняются — деньги возвращаются.',
  'el_refund_body': 'Если по вашей eSIM не израсходовано ни байта, возврат оформляется автоматически — без обращений в поддержку и без форм. Деньги вернутся на исходный способ оплаты или на баланс MobileTopup. Установили eSIM, но так и не подключились? Тоже вернём.',
  'el_details_h': 'eSIM в стране {c} — подробности',
  'el_networks_h': 'Сети и покрытие',
  'el_networks_p': 'Тарифы eSIM для {c} работают в основных местных мобильных сетях 4G/5G. Точная сеть каждого тарифа указана в его деталях перед покупкой.',
  'el_activation_h': 'Активация и срок действия',
  'el_act1': 'Устанавливайте в любое время — QR-код не сгорает. Установите дома до поездки.',
  'el_act2': 'Большинство тарифов начинают действовать при первом подключении к местной сети, а не при покупке — проверьте детали тарифа.',
  'el_act3': 'Только интернет — без местного номера. WhatsApp, Viber и iMessage продолжают работать с вашим номером.',
  'el_act4': 'Точка доступа и раздача интернета поддерживаются почти на всех тарифах.',
  'el_act5': 'Многие тарифы можно пополнить позже — новый QR-код не нужен.',
  'el_why_h': 'Почему eSIM, а не роуминг или местная SIM?',
  'el_why_p': 'Роуминг часто стоит $5–$10 в день. Местная SIM — это очередь в аэропорту с паспортом. eSIM для {c} избавляет от обоих: покупка онлайн за две минуты, домашняя SIM остаётся для звонков и OTP, а интернет — по местным ценам.',
  'el_faq_h': 'Частые вопросы',
  'el_faq1q': 'Как работает eSIM для {c}?',
  'el_faq1a': 'Купите тариф, отсканируйте присланный QR-код — и интернет заработает сразу по прибытии. Без замены SIM и без роуминга от вашего оператора.',
  'el_faq2q': 'Когда начинает действовать тариф?',
  'el_faq2a': 'Большинство тарифов активируются при первом подключении к местной сети, так что установить eSIM можно заранее. Отсчёт срока действия начинается с этого момента.',
  'el_faq3q': 'Совместим ли мой телефон?',
  'el_faq3a': 'Большинство телефонов с 2019 года поддерживают eSIM — iPhone XS и новее, свежие Samsung Galaxy, Google Pixel 3 и новее. Телефон должен быть разлочен. Наберите *#06# — если видите EID, всё в порядке.',
  'el_faq4q': 'Что, если я не использую eSIM?',
  'el_faq4a': 'eSIM с нулевым расходом трафика возвращаются автоматически — даже обращаться к нам не нужно.',
  'el_faq5q': 'Что такое дневной тариф?',
  'el_faq5a': 'Дневные тарифы дают пакет трафика, который обновляется каждый день. После его исчерпания скорость снижается до конца дня — без полного отключения.',
  'el_faq6q': 'Можно ли звонить и получать SMS?',
  'el_faq6a': 'eSIM — только для интернета, без местного номера. Звоните через WhatsApp, Viber или FaceTime. Домашняя SIM продолжит принимать SMS — просто отключите на ней роуминг данных.',
  'el_faq7q': 'Можно ли пополнить или продлить тариф?',
  'el_faq7a': 'Многие тарифы поддерживают пополнение — купите больше трафика для той же eSIM на странице заказов, без нового QR-кода и переустановки.',
  'el_faq8q': 'Какие способы оплаты вы принимаете?',
  'el_faq8a': 'Международные кредитные и дебетовые карты (с 3-D Secure), тайские банки, Alipay, USDC и баланс MobileTopup.',
  'el_also_topup': 'Нужно пополнить телефон? Пополните любой номер ({c})',
  'el_seo': 'Сравните тарифы eSIM для {c} по объёму и цене. MobileTopup.com присылает QR-код сразу после оплаты — установка за минуты, подключение по прибытии, и ту же eSIM можно пополнить позже. Цены прозрачные, без скрытых комиссий, а eSIM с нулевым расходом возвращаются автоматически. Работаем с 2009 года, доставлено более миллиона заказов.',

  'tmu_page_title': 'Пополнить меня',
  'tmu_page_sub': 'Попросите друзей или семью пополнить баланс вашего мобильного счёта',
  'tmu_how_it_works': 'Как это работает',
  'tmu_how_it_works_body': 'Поделитесь ссылкой по SMS, WhatsApp или email. Оплатить может кто угодно — без регистрации — и деньги сразу поступят на ваш баланс, готовые к использованию на мобильную связь, интернет или подарочные карты.',
  'tmu_link_created': 'Ссылка создана:',
  'tmu_your_profile': 'Ваш профиль',
  'tmu_profile_sub': 'Показывается тому, кого вы просите о помощи, чтобы он знал, что это действительно вы.',
  'tmu_photo_uploading': 'Загрузка…',
  'tmu_photo_set': 'Показывается тому, кого вы просите о помощи.',
  'tmu_photo_required': 'Обязательно — добавьте настоящее фото, чтобы отправитель знал, что это действительно вы.',
  'tmu_remove_photo': 'Удалить фото',
  'tmu_new_request': 'Новый запрос',
  'tmu_your_name': 'Ваше имя',
  'tmu_your_phone': 'Ваш номер телефона',
  'tmu_phone_hint': 'Это номер, на который поступит пополнение, и он отображается отправителю как подтверждение подлинности запроса.',
  'tmu_amount_label': 'Сумма',
  'tmu_amount_fixed': 'Фиксированная сумма',
  'tmu_amount_open': 'Пусть выберет отправитель',
  'tmu_requested_amount': 'Запрашиваемая сумма (฿)',
  'tmu_min_amount': 'Минимум (฿)',
  'tmu_max_amount': 'Максимум (฿)',
  'tmu_note_label': 'Сообщение отправителю',
  'tmu_note_placeholder': 'например, Пожалуйста, помогите пополнить мой телефон',
  'tmu_note_required_hint': 'Личное сообщение повышает доверие — обязательно к заполнению.',
  'tmu_cap_hint': 'До {cap} в сутки по всем вашим ссылкам. Комиссию оплачивает отправитель — вы всегда получаете полную сумму.',
  'tmu_photo_required_notice': 'Добавьте фото выше, прежде чем создать запрос.',
  'tmu_creating': 'Создание…',
  'tmu_create_link': 'Создать ссылку',
  'tmu_your_links': 'Ваши ссылки (активных: {count})',
  'tmu_links_error': 'Не удалось загрузить ваши ссылки. Обновите страницу и попробуйте снова.',
  'tmu_links_empty': 'У вас пока нет ссылок «Пополнить меня» — создайте первую выше.',
  'tmu_amount_fixed_suffix': 'фиксированная',
  'tmu_amount_open_suffix': '(открытая)',
  'tmu_received': 'Получено:',
  'tmu_of_cap_per_day': 'из {cap}/сутки',
  'tmu_copy_link': 'Скопировать ссылку',
  'tmu_copied': 'Скопировано',
  'tmu_share': 'Поделиться',
  'tmu_active': 'Активна',
  'tmu_cancelled': 'Отменена',
  'tmu_cancel_confirm': 'Отменить эту ссылку «Пополнить меня»? Те, у кого она уже есть, больше не смогут по ней заплатить.',
  'tmu_no_payments': 'Платежей пока нет.',
  'tmu_anonymous': 'Аноним',
  'tmu_share_in': 'Поделиться на языке',
  'tmu_send_title': 'Отправить пополнение',
  'tmu_loading': 'Загрузка…',
  'tmu_not_found': 'Эта ссылка не найдена.',
  'tmu_inactive': 'Эта ссылка больше не активна.',
  'tmu_checking_payment': 'Проверка статуса платежа…',
  'tmu_payment_success': 'Платёж отправлен — спасибо! {name} получит уведомление немедленно.',
  'tmu_payment_failed': 'Платёж не был завершён. Списания не было.',
  'tmu_payment_timeout': 'Платёж ещё обрабатывается — это может занять минуту. Повторно платить не нужно.',
  'tmu_asking_help': '{name} просит вашей помощи',
  'tmu_help_body': 'Помогите {firstName} пополнить связь и интернет, чтобы оставаться на связи с вами. Они будут благодарны за вашу помощь.',
  'tmu_note_says': '{name} пишет',
  'tmu_recipient_thailand': 'Получатель · Таиланд',
  'tmu_choose_amount': 'Выберите сумму для отправки',
  'tmu_amount_to': 'Сумма для {firstName}',
  'tmu_processing_fee': 'Комиссия за обработку платежа (оплачивается вами)',
  'tmu_total_pay': 'Итого к оплате',
  'tmu_payment_method': 'Способ оплаты',
  'tmu_card_label': 'Кредитная / дебетовая карта',
  'tmu_card_sub': 'Visa, Mastercard, JCB — удобнее всего из-за границы',
  'tmu_thai_label': 'Тайские платежи',
  'tmu_thai_sub': 'Банковские приложения и тайские кошельки',
  'tmu_your_email': 'Ваш email',
  'tmu_email_hint': 'Для вашей квитанции — регистрация не нужна.',
  'tmu_email_invalid': 'Введите корректный email для квитанции.',
  'tmu_starting_payment': 'Запуск платежа…',
  'tmu_send_amount': 'Отправить {amount}',
  'tmu_trust': 'Защищено Omise · mobiletopup.com никогда не хранит данные вашей карты.',
  'tmu_view_payments': 'Посмотреть платежи',
  'tmu_cancel_link': 'Отменить ссылку',
  'tmu_phone_placeholder': '08X XXX XXXX или +63 917 123 4567',
  'tmu_phone_examples': 'Тайский номер (08X XXX XXXX) или международный с кодом страны, например +63 917 123 4567.',
  'tmu_global_off': 'Международные номера пока не поддерживаются — используйте тайский мобильный номер.',
  'tmu_requests_in_thb': 'Запросы в THB · {range}',
  'tmu_requests_in_usd': 'Запросы в USD · {range}',
  'tmu_requested_amount_usd': 'Запрашиваемая сумма ($ USD)',
  'tmu_min_amount_usd': 'Минимум ($)',
  'tmu_max_amount_usd': 'Максимум ($)',
  'tmu_cap_hint_usd': 'Сумма одного запроса: {range}. Комиссию за обработку и конвертацию валюты оплачивает отправитель — вы всегда получаете полную сумму в USD.',
  'tmu_verify_cta': 'Подтвердить этот номер по SMS (необязательно)',
  'tmu_verify_why': 'Значок «Подтверждён» показывает отправителям, что номер действительно ваш.',
  'tmu_verify_sending': 'Отправка…',
  'tmu_verify_code_sent': 'Код отправлен. Введите 6-значный код из SMS.',
  'tmu_verify_code_label': '6-значный код',
  'tmu_verify_confirm': 'Подтвердить',
  'tmu_verify_checking': 'Проверка…',
  'tmu_verify_resend': 'Отправить код ещё раз',
  'tmu_verify_send_failed': 'Не удалось отправить код. Проверьте номер и попробуйте снова.',
  'tmu_verify_failed': 'Код не подошёл. Проверьте его и попробуйте снова.',
  'tmu_verify_too_many': 'Слишком много попыток. Подождите несколько минут и повторите.',
  'tmu_verified': 'Подтверждён',
  'tmu_not_verified': 'Не подтверждён',
  'tmu_verified_number': 'Подтверждённый номер',
  'tmu_top_up_number': 'Пополнить этот номер',
  'tmu_recipient_in': 'Получатель · {country}',
  'tmu_receives': '{firstName} получает',
  'tmu_total_usd': 'Итого (USD)',
  'tmu_charged_thb': 'С вас спишут {amount} (≈ {rate} THB за 1 USD)',
  'tmu_pay_amount': 'Оплатить {amount}'
}
